import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ReportingDataService } from '../shared/services/reporting-data.service';

@Component({
  selector: 'app-reporting-value',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './reporting-value.component.html',
  styleUrl: './reporting-value.component.scss'
})
export class ReportingValueComponent {

  get kpiCards() { return this.dataService.valueKpis; }
  get valueNamcRows() { return this.dataService.valueNamcRows; }
  get timeSavingsRows() { return this.dataService.timeSavingsRows; }
  readonly pageFilters = ['YTD', 'All NAMCs', 'Validated Benefits'];

  selectedNamc = 'ALL';

  get filteredTimeSavingsRows() {
    return this.selectedNamc === 'ALL'
      ? this.timeSavingsRows
      : this.timeSavingsRows.filter(r => r.namc === this.selectedNamc);
  }

  trackByRank(_: number, row: { rank: number }): number { return row.rank; }
  trackByIndex(index: number): number { return index; }

  constructor(private readonly dataService: ReportingDataService) {}
}
